export enum StateContext {
    UNDEFINED = "undefined",
    INSPECTION = "inspection_",
    SOLUTION_AUTHORING_CONTENT = "solution_authoring_content_",
    SOLUTION_AUTHORING_ISSUE_PICKER = "solution_authoring_issue_picker_",
    SOLUTION_VIEWING = "solution_viewing_"
}
